import { Pipe, PipeTransform } from '@angular/core';
import { toTwelveHourTime } from '../../../core/pure-functions/time/time';

@Pipe({ name: 'militaryTimeToString' })
export class MilitaryTimeToStringPipe implements PipeTransform {
  transform(timeString: string): string {
    return toTwelveHourTime(timeString);
  }
}
